/**
 * Management components index file
 * Exports all management components from the management directory
 */

// Import management components
import VariationManagementEnh from './VariationManagement-enh';
import LitGroupManagementEnh from './LitGroupManagement-enh';
import BookManagementEnh from './BookManagement-enh';
import BookManagementBc from './BookManagement-bc';
import CharacterManagementEnh from './CharacterManagement-enh';

// Export management components
export {
  VariationManagementEnh,
  LitGroupManagementEnh,
  BookManagementEnh,
  BookManagementBc,
  CharacterManagementEnh
};

// Export default
export default {
  VariationManagementEnh,
  LitGroupManagementEnh,
  BookManagementEnh,
  BookManagementBc,
  CharacterManagementEnh
};
